let appMode = process.env.REACT_APP_ENV;
let ASSET_URL = "https://s3-noi.aces3.ai/invent-co-new/";
let URL;

console.log("appMode", appMode);

if (appMode === "development") {
  // URL = "http://103.189.173.7:7065/";
  URL = "http://16.26.92.101:8000/api/v1/";
  // URL = "http://127.0.0.1:8000/api/v1/";
} else {
  // URL = "http://45.194.47.66:8015/api/v1/";
  // URL = "http://127.0.0.1:8000/api/v1/";
  URL = "https://backend.fusionhub.studio/api/v1/";
}

let apiPath = {
  baseURL: URL,
  assetURL: ASSET_URL,
  dashboard: "user/dashboard",
  dashboardTable: "vendor/dashboard/dashboard-table",

  listOrder: "vendor/order/list",
  viewOrder: "vendor/order/view",
  statusOrder: "vendor/order/status",

  listTransaction: "vendor/transaction/list",
  viewTransaction: "vendor/transaction/view",

  // Auth API
  logout: "auth/logout",
  login: "auth/login",
  verifyOTP: "auth/verify_otp",
  profile: "auth/profile",
  updateProfile: "auth/profile_update",
  changePassword: "/auth/change_password",
  updateAppSetting: "vendor/auth/update-app-setting",
  forgotPassword: "auth/forgot_password",
  resetPassword: "auth/reset_password",
  resetPasswordWithToken: (token) => `auth/reset_password/${token}`,
  validateUser: "vendor/auth/me",

  // user APIs
  userList: "vendor/user/list",
  userAddEdit: "vendor/user/add-edit",
  userStatusChanges: "vendor/user/status-change",
  userDelete: "vendor/user/delete",
  userViewDetail: "vendor/user/view",
  vendorList: "admin/user_list",
  usersList: "admin/user_list",
  // opsList: "user/user_list",
  adminList: "admin/user_list",
  // Category APIs
  // CategoryList: "vendor/sport-category/list",
  // CategoryAddEdit: "vendor/sport-category/add-edit",
  // CategoryStatusChanges: "vendor/sport-category/status-change",
  // categoryDelete: "vendor/sport-category/delete",
  // updatePriorityBulk: "vendor/sport-category/update-priority",

  // Wallet Payment APIs
  // getWalletPayment: "vendor/wallet-payment/list",
  // approveRejectWithdrawRequest: "vendor/wallet-payment/approve-reject-request",

  // Banner APIs
  // bannerList: "vendor/banner/list",
  // addEditBanner: "vendor/banner/add-edit",
  // updateOrderBanner: "vendor/banner/update-order",
  // bannerDelete: "vendor/banner/delete",
  // bannerView: "vendor/banner/view",
  // serviceStatusChange: "vendor/banner/status-change",

  // Service APIs
  // serviceList: "vendor/service/list",
  // addEditService: "vendor/service/add-edit",
  // serviceDelete: "vendor/service/delete",
  // serviceView: "vendor/service/view",
  // serviceStatusChange: "vendor/service/status-change",
  // activeService: "service/active_service",

  // Product APIs
  productList: "service/product_list",
  productCreate: "service/product_create",
  updateProduct: "service/product_update",
  updateProductStatus: "service/product_status_update",
  productDelete: "product/delete",
  productView: "product/view",

  // Staff APIs
  // staffList: "vendor/staff/list",
  // addEditStaff: "vendor/staff/add-edit",
  // staffDelete: "vendor/staff/delete",
  // staffView: "vendor/staff/view",
  // staffStatusChange: "vendor/staff/status-change",

  // Financial APIs
  // getTransaction: "financial/transaction_list",
  // updateSuspicious: "financial/is_suspicious",
  // downloadTransactions: "financial/transaction_history",
  // getVendorPayouts: "financial/payout_list",
  // updateVendorPayoutStatus: "financial/vendor_settlements",

  // FAQ APIs
  // faqList: "vendor/faq/list",
  // faqAddEdit: "vendor/faq/add-edit",
  // faqStatusChange: "vendor/faq/status-change",
  // faqView: "vendor/faq/view",
  // faqDelete: "vendor/faq/delete",

  //Report Analytics APIs
  // dauData: "vendor/report-analytics/get-dau", //daily active users
  // mostPlayedCategoryData: "vendor/report-analytics/most-played-categories",

  // EmailTemplate APIs

  getAllEmails: "email/get_all_email",
  getEmailById: "email/get_email_by_id",
  updateEmail: "email/update_email",

  // Content APIs

  getAllContent: "content/get_all_contents",
  getContentById: "content/get_content_by_id",
  updateContent: "content/update_content",

  // Role APIs---
  // role: "vendor/role",

  // SubAdmin APIs
  // subAdmin: "vendor/sub-admin",
  // getModule: "vendor/sub-vendor/module-list",
  // addPermission: "vendor/sub-vendor/add-permission",

  // Role Permissions APIs---
  // rolePermissions: "vendor/role-permission",

  // adminCommon: "vendor/common",

  // notification: "vendor/notification",
  // deleteUserNotification: "vendor/notification/delete-user-notification",

  //Common apis
  // common: {
  //   countries: "common/country",
  //   categoryCommonList: "common/category-list",
  //   userList: "common/users-list",
  // },

  // Auth API
  logout: "auth/logout",
  signUp: "vendor/auth/sign-up",

  // Order APIs
  // orderList: "booking/booking_list",
  // activeVendorList: "booking/active_vendor",
  // assignVendor: "booking/assign_vendor",
  // orderDetail: "booking/get_booking_details",
  // orderStatusChange: "vendor/order/status-change",
  // orderDelete: "vendor/order/delete",
};

export default apiPath;